// extracted by mini-css-extract-plugin
export default {"modal":"MY-z","error":"NY-z","disabled":"OY-z","fields":"PY-z","errorMsg":"QY-z","footer":"RY-z","formContentWrapper":"SY-z","productImage":"TY-z","overlay":"UY-z"};